document.addEventListener('DOMContentLoaded', function () {
  var range = document.getElementById('zd-compareRange');
  var after = document.getElementById('zd-afterLayer');
  var handle = document.getElementById('zd-handleLine');
  var grip = document.getElementById('zd-grip');
  var navToggle = document.getElementById('zd-navToggle');
  var navLinks = document.getElementById('zd-navLinks');

  if (range && after && handle && grip) {
    function update(v) {
      after.style.clipPath = 'inset(0 0 0 ' + v + '%)';
      handle.style.left = v + '%';
      grip.style.left = v + '%';
    }
    range.addEventListener('input', function (e) { update(e.target.value); });
    update(50);
  }

  if (navToggle && navLinks) {
    navToggle.addEventListener('click', function () {
      navLinks.classList.toggle('open');
    });
  }

  var form = document.getElementById('zd-contact-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      var note = form.querySelector('.zd-submit-note');
      if (note) note.style.display = 'block';
    });
  }

  // Smooth fade-in on load (avoids the page "popping" in unstyled)
  var scope = document.querySelector('.zd-scope');
  if (scope) {
    requestAnimationFrame(function () {
      scope.classList.add('zd-loaded');
    });
  }

  // Scroll reveal: fade + rise each section/card into place as it enters view
  var revealTargets = document.querySelectorAll(
    '.hero-inner, .account-block, .contact-grid, .work-card, .testi, .service-card, .process-row'
  );
  revealTargets.forEach(function (el) { el.classList.add('zd-reveal'); });

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('zd-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    revealTargets.forEach(function (el) { observer.observe(el); });
  } else {
    // Fallback for very old browsers: just show everything
    revealTargets.forEach(function (el) { el.classList.add('zd-visible'); });
  }
});
